<template>
  <div>
    <!-- 左メニュー -->
    <v-navigation-drawer
        v-model="computedDrawer"
        app
        color="drawer"
        floating
        id="urepo-menu"
        mobile-breakpoint="1024"
    >
      <div class="drawer-logo" style="padding: 7px 0px 7px 16px;">
        <v-img
          :src="require('/src/assets/images/logo.svg')"
          contain
          :aspect-ratio="3/1"
          width="150px"
          height="50px"
          position="left"
        />
      </div>
      <v-divider></v-divider>

      <v-list dense>
        <template v-for="(item, index) in navItems">
          <v-row
              v-if="item.heading"
              :key="item.heading"
              align="center"
          >
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
          </v-row>

          <v-list-group
              v-else-if="item.children"
              :key="item.text"
              v-model="item.model"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon=""
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
                v-for="(child, i) in item.children"
                :key="i"
                :to="child.to"
                class="ml-5 "
                link
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item
              v-else
              :key="item.text"
              :to="item.to"
              link
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>

          </v-list-item>

          <v-divider
              v-if="index !== 0"
              :key="index"
              class="mx-4"
          ></v-divider>

        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      navItems: [
        {heading: 'MENU'},
        {icon: 'mdi-account-multiple', text: '担当者管理', to: '/'},
      ],
    }
  },
  props: {
    drawer: {
      type: Boolean
    }
  },
  mounted() {
    if(this.isAgreementSetting) {
      this.navItems.push({icon: 'mdi-file-document-edit-outline', text: '契約管理', to: '/setting/agreement'})
    }
  },
  computed: {
    ...mapGetters ({
      isAgreementSetting: 'auth/is_agreement_setting'
    }),
    computedDrawer: {
      get() {
        return this.drawer
      },
      set(drawer) {
        this.$emit('input', drawer)
      }
    }
  }
}
</script>
